export default __webpack_public_path__ + "static/media/Terminal-red.a90d4a22.svg";